
import { axiosPost } from '../../axios/axios.js'
import { EventBus } from '../../EventBus/EventBus.js'
import CardPropertyTable from '../../components/Card/CardPropertyTable.vue'
import EmployeeEmploymentPeriodEdit from './EmployeeEmploymentPeriodEdit.vue'

export default {
  extends: CardPropertyTable,
  data: function () {
    return {
      addFn: () => this.onRowClick(null, null), // @Override
      deleteIconName: 'mdi-delete', // @Override
      deleteButtonTooltipText: 'Удалить' // @Override
    }
  },
  computed: {
    rows: function () {
      return this.propertyRows.length ? this.propertyRows : [{
        editTime: null,
        user: null,
        employmentDate: this.objectInitial.employmentDate,
        resignationDate: this.objectInitial.resignationDate
      }]
    }
  },
  methods: {
    // @Override
    onRowClick: function ($event, row) {
      const rowIndex = row ? this.rows.findIndex(r => r === row) : -1
      const dialog = this.$d.dialog(this).show({
        noWrap: true,
        contentWidth: 400,
        contentComponent: EmployeeEmploymentPeriodEdit,
        contentProps: {
          period: row || {
            employmentDate: null,
            resignationDate: null
          }
        },
        componentHandlers: {
          save: (period) => {
            const periods = this.rows.map((r, i) => {
              return i === rowIndex ? period : {
                employmentDate: r.employmentDate,
                resignationDate: r.resignationDate,
                user: r.user,
                editTime: r.editTime
              }
            })
            if (rowIndex === -1) {
              periods.push(period)
            }
            const periodsEncoded = encodeURIComponent(JSON.stringify(periods))
            axiosPost({
              url: `service/delta/employee/save?id=${this.object.id}&employmentPeriods=${periodsEncoded}`,
              onSuccess: (response) => {
                EventBus.$emit('update-structure')
              },
              onFailure: ''
            }).finally(() => {
              dialog.hide()
            })
          },
          cancel: () => {
            dialog.hide()
          }
        }
      })
    }
  }
}

